import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CoffeeBreakroomPage = lazy(() => import('../pages/coffee-breakroom/page'));
const FurnitureInteriorsPage = lazy(() => import('../pages/furniture-interiors/page'));
const FacilitiesMaintenancePage = lazy(() => import('../pages/facilities-maintenance/page'));
const TechnologySolutionsPage = lazy(() => import('../pages/technology-solutions/page'));
const PromotionalProductsPage = lazy(() => import('../pages/promotional-products/page'));
const OfficeEssentialsPage = lazy(() => import('../pages/office-essentials/page'));
const K12SchoolsPage = lazy(() => import('../pages/k12-schools/page'));
const HealthcarePage = lazy(() => import('../pages/healthcare/page'));
const CommercialAccountsPage = lazy(() => import("../pages/commercial-accounts/page"));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/divisions/coffee-and-breakroom',
    element: <CoffeeBreakroomPage />,
  },
  {
    path: '/divisions/furniture-and-interiors',
    element: <FurnitureInteriorsPage />,
  },
  {
    path: '/divisions/facilities-and-maintenance',
    element: <FacilitiesMaintenancePage />,
  },
  {
    path: '/divisions/technology-solutions',
    element: <TechnologySolutionsPage />,
  },
  {
    path: '/divisions/promotional-products',
    element: <PromotionalProductsPage />,
  },
  {
    path: '/divisions/office-essentials',
    element: <OfficeEssentialsPage />,
  },
  {
    path: '/markets/k-12-schools',
    element: <K12SchoolsPage />,
  },
  {
    path: '/markets/healthcare',
    element: <HealthcarePage />,
  },
  {
    path: '/markets/national-accounts',
    element: <CommercialAccountsPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
